export default __webpack_public_path__ + "static/media/vnpt_invoice.a526e09a.jpg";